import { useState } from "react";
import { useDispatch } from "react-redux";

import { bulkRejectAdminEventRequestsRequest } from "../../../../../../store/AdminEventRequests/actions";

const useAdminRejectRequests = ({
  rows,
  selectedIds,
  listParams,
  setSelectedIds,
}) => {
  const dispatch = useDispatch();
  const [rejectTargetIds, setRejectTargetIds] = useState([]);
  const rejectApplicants = rows.filter((row) =>
    rejectTargetIds.includes(row.id),
  );

  const openRejectModal = () => {
    setRejectTargetIds(selectedIds);
  };

  const closeRejectModal = () => {
    setRejectTargetIds([]);
  };

  const confirmReject = ({ reason }) => {
    dispatch(
      bulkRejectAdminEventRequestsRequest({
        eventRequestIds: rejectTargetIds,
        rejectionReason: reason,
        listParams,
        onSuccess: () => {
          setSelectedIds([]);
          setRejectTargetIds([]);
        },
      }),
    );
  };

  return {
    rejectApplicants,
    isRejectModalOpen: rejectTargetIds.length > 0,
    openRejectModal,
    closeRejectModal,
    confirmReject,
  };
};

export default useAdminRejectRequests;
